<template>
  <div class="statistics-box">
    <!-- Filter bar -->
    <div v-if="filterseller && currentUser && currentUser.type && currentUser.role && currentUser.role.name" class="stat-filter-bar">
      <div class="stat-filter-row">
        <div class="stat-filter-item" v-if="currentUser.role.name!='Seller' && currentUser.type!='Seller'">
          <v-select @search="getUsersDebance($event,'shipsen')" @input="CheckSellerProducts($event,action,'seller')" label="fullName" placeholder="Seller" :options="sellers" v-model="sellerdata" class="stat-filter-select"></v-select>
        </div>
        <div class="stat-filter-item">
          <v-select @search="getProducts($event,'shipsen')" @input="CheckSellerProducts($event,action,'product')" label="name" placeholder="Product" :options="products" v-model="productdata" class="stat-filter-select"></v-select>
        </div>
        <button class="stat-filter-clear" @click="removedata(action)"><i class="material-icons" style="font-size:16px">close</i></button>
      </div>
      <div v-if="filter && timeserchtype=='betweendate'" class="stat-filter-date">
        <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="stat-datepicker" v-model="fromDate" range></date-picker>
        <button @click="FindRecordsBetweenDate()" :class="!fromDate?'noselect':''" :disabled="!fromDate" class="stat-filter-search"><i class="material-icons" style="font-size:18px">search</i></button>
      </div>
    </div>

    <!-- Refresh overlay -->
    <div v-if="refresh && timeserchtype=='...'" @click="Refrechdata(action)" class="vld-overlay-refrech">
      <div class="vld-background" style="backdrop-filter: blur(2px);"></div>
      <button class="btnn box flex items-center text-gray-700 cursor-not-allowed pointer-events-none">
        <img class="analytics-imgg" src="https://img.icons8.com/office/80/000000/refresh--v1.png"/> Refresh
      </button>
    </div>

    <loading :active.sync="loading" :is-full-page="fullPage"></loading>

    <!-- Header row: Icon + Title + Date -->
    <div class="s2-header">
      <div class="s2-icon" :class="[statIconColor]">
        <i class="material-icons" style="font-size:20px">{{ iconMap }}</i>
      </div>
      <div class="s2-header-info">
        <span class="s2-title">{{statSubtitle}}</span>
        <select v-if="filter" :name="action" @change="ChangeDateConfirmationRate($event)" v-model="timeserchtype" class="s2-date-select">
          <option value="all">All</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="thisweek">This week</option>
          <option value="lastweek">Last week</option>
          <option value="thismonth">This Month</option>
          <option value="lastmonth">Last Month</option>
          <option value="thisyear">This Year</option>
          <option value="betweendate">Between date</option>
        </select>
      </div>
    </div>

    <!-- Value -->
    <div class="s2-value-section">
      <div class="s2-value">{{datas.sum||datas.rate}} <sup class="s2-currency">{{currency}}</sup></div>
      <div v-if="statSubtitle1" class="s2-gen-value">{{datas.sum1}} {{currency}} ({{statSubtitle1}})</div>
    </div>

    <!-- Chart at bottom -->
    <div class="s2-chart-bottom" :class="{ 's2-chart-compact': hasBreakdown }" :id="id"></div>

    <!-- Stats breakdown -->
    <div class="s2-breakdown" v-if="datas.countAll || datas.countAll==0">
      <div class="s2-stat-row"><span class="s2-dot" style="background:#64748b"></span><span>{{action=='ConfirmationRate'?'Total Orders':'Total Shippings'}}</span><span class="s2-stat-val">{{datas.countAll}}</span></div>
      <div v-if="action=='ConfirmationRate' && (datas.confirmed || datas.confirmed==0)" class="s2-stat-row"><span class="s2-dot" style="background:#22c55e"></span><span>Confirmed</span><span class="s2-stat-val">{{datas.confirmed}} ({{getPercentege(datas.confirmed,datas.countAll)}}%)</span></div>
      <div v-if="action=='ConfirmationRate' && (datas.cancelled || datas.cancelled==0)" class="s2-stat-row"><span class="s2-dot" style="background:#ef4444"></span><span>Cancelled</span><span class="s2-stat-val">{{datas.cancelled}} ({{getPercentege(datas.cancelled,datas.countAll)}}%)</span></div>
      <div v-if="action=='Delivery'" class="s2-grid-2">
        <div v-if="datas.received || datas.received==0" class="s2-stat-row"><span class="s2-dot" style="background:#22c55e"></span><span>Received</span><span class="s2-stat-val">{{datas.received}} ({{getPercentege(datas.received,datas.countAll)}}%)</span></div>
        <div v-if="datas.paid || datas.paid==0" class="s2-stat-row"><span class="s2-dot" style="background:#e9ad63"></span><span>Paid</span><span class="s2-stat-val">{{datas.paid}} ({{getPercentege(datas.paid,datas.countAll)}}%)</span></div>
        <div v-if="datas.cancelled || datas.cancelled==0" class="s2-stat-row"><span class="s2-dot" style="background:#ef4444"></span><span>Cancelled</span><span class="s2-stat-val">{{datas.cancelled}} ({{getPercentege(datas.cancelled,datas.countAll)}}%)</span></div>
        <div v-if="datas.processed || datas.processed==0" class="s2-stat-row"><span class="s2-dot" style="background:#bb07e9"></span><span>Processed</span><span class="s2-stat-val">{{datas.processed}} ({{getPercentege(datas.processed,datas.countAll)}}%)</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "card-stats-v2",
  props: {
    statSubtitle: {
      default: "Traffic",
    },
    loading:{required:false},
    timeserch:{},
    titleRate:{},
    from:{},
    to:{},
    seller:{},
    product:{},
    filter: {
      default: false,
    },
    filterseller: {
      default: false,
    },
    refresh: {
      default: false,
    },
    statTitle: {},
    action: {},
    statArrow: {
      default: "up",
      validator: function (value) {
        // The value must match one of these strings
        return ["up", "down"].indexOf(value) !== -1;
      },
    },
    statPercent: {},
    // can be any of the text color utilities
    // from tailwindcss
    statPercentColor: {
      default: "text-green-500",
    },
    statDescripiron: {},
    statSubtitle1:{type:String},
    id:{type:String},
    color:{type:String},
    currency: {default:false},
    count:{type: Number,default:0},
    datas:{type:Object},
    currentUser:{type:Object},
    warhouse:{type:Object},
    dataChart:{type:Array},
    sellers:{type:Array},
    products:{type:Array},
    countText:{},
    rate:{},
    statIconName: {
      default: "far fa-chart-bar",
    },
    // can be any of the background color utilities
    // from tailwindcss
    statIconColor: {
      type: String,
      default: "bg-red-500",
    },
  },
  data() {
    return {
      fullPage: false,
      timeserchtype:this.timeserch,
      sellerdata:this.seller,
      productdata:this.product,
      myChart: "",
      fromDate:this.from,
      toDate:this.to,
    };
  },
 watch: {
    dataChart: function () {
      if (this.myChart != null) this.myChart.destroy();
      this.drawChart(this.dataChart);
      this.myChart.render();
    },
    'timeserch': function () {
      this.timeserchtype=this.timeserch;
    },
   'seller': function () {
     console.log('seller------',this.seller)
      this.sellerdata=this.seller;
   },
   'product': function () {
     console.log('product------',this.product)
      this.productdata=this.product;
   },
  },
  async mounted(){
    //  var chart = new ApexCharts(document.querySelector("#"+this.id), this.options);
	  //   chart.render();
     await this.drawChart(this.dataChart);
     this.myChart.render();
     if(this.currentUser && this.currentUser.role && this.currentUser.role.name=='Seller' && this.currentUser.type=='Seller') this.sellerdata=this.currentUser;

  },
   computed: {
     hasBreakdown() {
       return this.action === 'ConfirmationRate' || this.action === 'Delivery';
     },
     iconMap() {
       const icons = {
         'timeline': 'check_circle',
         'delivery': 'local_shipping',
         'monetization_on': 'account_balance_wallet',
       };
       return icons[this.statIconName] || this.statIconName;
     },
   },
   methods: {
     getPercentege(countStatus,total){
         return total?Math.round((countStatus * 100) /  total):0;
     },
    FindRecordsBetweenDate: function (val) {
         this.$emit("FindRecordsBetweenDate", this.action,this.fromDate,this.toDate);
    },
    FindRecordsSellers: function (val) {
        this.$emit("FindRecordsSellers", this.action,this.sellerdata,this.productdata);
    },
    getUsersDebance: function (name) {
        this.$emit("getUsersDebance", name);
     }, 
    getProducts: function (name) {
        this.$emit("getProducts", name);
     }, 
    async CheckSellerProducts(seller,action,model){
       this.$emit("CheckSellerProducts", seller,action,model);
    },
    removedata: function (val) {
        this.$emit("removedata", this.action);
     }, 
    drawChart(chartData) {
        var ctx = document.getElementById(this.id);
        this.myChart = new ApexCharts(ctx, {
        chart: {
          height: (this.action === 'PendingRevenu' || !this.action) ? 120 : 60,
          width: '100%',
          type: 'area',
          zoom: {
            enabled: false
          },
          foreColor: '#4e4e4e',
          toolbar: {
            show: false
          },
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: false,
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2.5,
          curve: 'smooth'
        },
        series: [{
          name: this.statSubtitle,
          data: chartData
        }],
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return parseInt(val);
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            gradientToColors: [this.color],
            shadeIntensity: 1,
            type: 'vertical',
            opacityFrom: 0.3,
            opacityTo: 0.05,
            stops: [0, 90, 100]
          },
        },
        colors: [this.color],
        legend: {
          show: false,
        },
        grid: {
          show: false,
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: false
          },
        }
       });
    },
    ChangeDateConfirmationRate: function (val) { 
      if(val.target.name=="ConfirmationRate")  this.$emit("ChangeDateConfirmationRate", val);
      if(val.target.name=="Delivery") this.$emit("ChangeDateConfirmationDelevry", val);
    },
    Refrechdata: function (val) { 
        this.$emit("Refrechdata", val);
    },
    //  FindRecords: function () {
    //   this.$emit("FindRecords", this.action,this.fromDate,this.toDate);
    // },
   }
};
</script>
<style scoped>
/* Filter bar */
.stat-filter-bar {
  background: #f8fafc;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 12px;
}
.stat-filter-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.stat-filter-item {
  flex: 1;
  min-width: 0;
}
.stat-filter-select {
  font-size: 12px !important;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.stat-filter-clear {
  width: 30px;
  height: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  background: #fee2e2;
  color: #ef4444;
  cursor: pointer;
  transition: all 0.2s;
}
.stat-filter-clear:hover {
  background: #fecaca;
}
.stat-filter-date {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}
.stat-datepicker {
  flex: 1;
}
.stat-filter-search {
  width: 34px;
  height: 34px;
  min-width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  background: #4285f4;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
}
.stat-filter-search:hover {
  background: #3367d6;
}
.stat-filter-search.noselect {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Card base */
.statistics-box {
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  margin-bottom: 0;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  padding: 14px 16px;
  transition: all 0.3s ease;
  flex: 1 1 auto;
  min-height: 1px;
  display: flex;
  flex-direction: column;
}
.statistics-box:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.statistics-box:before,
.statistics-box:after {
  display: none;
}

/* Header row: Icon + Title + Date */
.s2-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.s2-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;
}
.s2-header-info {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
}
.s2-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}
.s2-date-select {
  appearance: auto;
  font-size: 11px;
  font-weight: 500;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 3px 8px;
  cursor: pointer;
  outline: none;
}

/* Value */
.s2-value-section {
  margin-bottom: 6px;
}
.s2-value {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}
.s2-currency {
  font-size: 10px;
  font-weight: 600;
  color: #64748b;
}
.s2-gen-value {
  font-size: 10px;
  font-weight: 600;
  color: #4285f4;
  background: #eff6ff;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
  margin-top: 2px;
}

/* Chart at bottom - fills remaining space */
.s2-chart-bottom {
  margin: auto -16px -14px -16px;
}
.s2-chart-bottom.s2-chart-compact {
  margin: 0 -16px 10px -16px;
}

/* Breakdown stats */
.s2-breakdown {
  margin-top: 6px;
}
.s2-stat-row {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #475569;
  padding: 2px 0;
}
.s2-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  flex-shrink: 0;
}
.s2-stat-val {
  margin-left: auto;
  font-weight: 600;
  color: #1e293b;
}
.s2-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 12px;
}
</style>
